/**
 * 將登入員工對應到「分支員工」列中用於結帳的 employee id。
 * - 一般用戶：Redux employeeInfo.employeeId 通常等於分店員工的 id。
 * - 管理者等：常見 employeeId 為 -1，需改用 admin_users_id / adminUsersId 比對分店列上的 admin_users_id。
 */
export function resolveCashierBranchEmployeeId(employeeInfo, branchEmployees) {
  const list = Array.isArray(branchEmployees) ? branchEmployees : [];
  if (!list.length) {
    return { id: null, reason: "no_branch_employees" };
  }
  if (!employeeInfo || typeof employeeInfo !== "object") {
    return { id: null, reason: "no_employee_info" };
  }

  const pid = employeeInfo.employeeId;
  if (pid != null && pid !== "" && Number(pid) > 0) {
    const row = list.find((e) => Number(e.id) === Number(pid));
    if (row) return { id: row.id, reason: "matched_branch_employee_id" };
    return { id: null, reason: "positive_employee_id_not_in_branch_list" };
  }

  const adminUid =
    employeeInfo.adminUsersId ??
    employeeInfo.admin_users_id ??
    employeeInfo.adminUserId;
  if (adminUid != null && adminUid !== "" && Number(adminUid) > 0) {
    const row = list.find(
      (e) => Number(e.admin_users_id) === Number(adminUid)
    );
    if (row) return { id: row.id, reason: "matched_admin_users_id" };
    return { id: null, reason: "admin_user_id_not_in_branch_list" };
  }

  if (pid == null || pid === "" || Number(pid) <= 0) {
    return {
      id: null,
      reason: "sentinel_or_invalid_login_employee_id",
    };
  }

  return { id: null, reason: "unmatched" };
}
